import React from 'react';

import DataFlowIcon from '@atlaskit/icon/core/data-flow';
import { IconButton } from '@atlaskit/button/new';

import { useWorkflowsPanel } from '@confluence/advanced-workflows/entry-points/useWorkflowsPanel';
import { useAIRovoButtonEnablement } from '@confluence/ai-floating-context-menu/entry-points/useAIRovoButtonEnablement';

export const WorkflowsPanelButton = () => {
	const { showWorkflowsPanel } = useWorkflowsPanel();
	const isRovoButtonEnabled = useAIRovoButtonEnablement();

	return (
		<IconButton
			icon={DataFlowIcon}
			appearance="subtle"
			shape={isRovoButtonEnabled ? 'default' : 'circle'}
			label=""
			testId="sidebar-workflows-button"
			onClick={showWorkflowsPanel}
			tooltip={{
				position: 'left',
			}}
			data-vc="object-sidebar-workflows-button"
		/>
	);
};
